import React from 'react';
import glamorous from 'glamorous';

const Flex = glamorous.div(
  {
    display: 'flex',
  },
  ({ stacked }) => ({
    flexDirection: stacked ? 'column' : 'row',
  })
);

const getBlockSize = count => size => `${size / count * 100}%`;

const Block = glamorous.div(({ width, blockStyle }) => {
  return {
    width,
    ...blockStyle,
  };
});

const ResponsiveRow = ({ children, stacked = false, blockCount, style }) => {
  const totalBlocks =
    blockCount ||
    React.Children
      .toArray(children)
      .reduce((acc, curr) => acc + curr.props.blockSize, 0);
  const sizeCalc = getBlockSize(totalBlocks);
  return (
    <Flex {...{ stacked, style }}>
      {React.Children.map(children, curr => {
        return (
          <Block
            width={stacked ? '100%' : sizeCalc(curr.props.blockSize)}
            blockStyle={curr.props.blockStyle}
          >
            {curr}
          </Block>
        );
      })}
    </Flex>
  );
};

export default ResponsiveRow;



// WEBPACK FOOTER //
// ./src/App/join/Templates/Elements/ResponsiveRow.js